import axios, { AxiosResponse } from 'axios';
import readTenantCodeFromUrl from 'src/utils/readTenantCodeFromUrl';

export const callApi = async (
  method: 'GET' | 'POST' | 'DELETE' | 'PUT',
  url: string,
  onAceesFail: (error?: any) => void,
  onAceesSuccess: (response: AxiosResponse) => void,
  values?: any
): Promise<void> => {
  // Get the tenant code from the URL
  const tenantCode = readTenantCodeFromUrl();
  console.log('Tenant Code:', tenantCode); // Log the tenant code

  let formData: any = {
    method: method
  };

  if (values !== undefined && values !== '') {
    formData['data'] = values;
  }

  console.log('URL:', url, 'Form Data:', formData);

  try {
    switch (method) {
      case 'GET':
        const getResponse = await axios.get(url, formData);
        if (getResponse.status === 200) {
          onAceesSuccess(getResponse);
        } else {
          onAceesFail(getResponse);
        }
        break;

      case 'POST':
        const postResponse = await axios.post(url, values, formData);
        if (postResponse.status === 200 || postResponse.status === 201) {
          onAceesSuccess(postResponse);
        } else {
          onAceesFail(postResponse);
        }
        break;

      case 'DELETE':
        const deleteResponse = await axios.delete(url, {
          data: values,
          ...formData
        });
        if (deleteResponse.status === 200) {
          onAceesSuccess(deleteResponse);
        } else {
          onAceesFail();
        }
        break;

      case 'PUT':
        const updateResponse = await axios.put(url, formData);
        if (updateResponse.status === 200) {
          onAceesSuccess(updateResponse);
        } else {
          onAceesFail(updateResponse);
        }
        break;

      default:
        break;
    }
  } catch (error) {
    if (error) {
      onAceesFail(error);
    }
    throw error;
  }
};
